/**
* @author 贝才[beica1@outook.com]
* @date 2021/4/27
* @description
*   TheLiveNotice.vue of WeTrade
*/
<template>
  <div v-show="show" class="df-middle notice px-8">
    <Pic src="membership/loud" width="24" height="24" />
    <p class="flex-1 mx-16 f-md" style="line-height: 14px">{{content}}</p>
    <Icon name="close" lg @click="show = false" />
  </div>
</template>

<script lang="ts">
import Icon from '@/components/Icon.vue'
import Pic from '@/components/Pic.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TheLiveNotice',
  components: { Pic, Icon },
  props: {
    content: {
      content: String,
      required: true,
    },
  },
  data () {
    return {
      show: true,
    }
  },
})
</script>

<style scoped lang="scss">
.notice {
  height: 48px;
  color: var(--color-asst);
  background: var(--color-asst-light);
}
</style>
